import React from "react";
import {
  Box,
  FormControlLabel,
  Switch,
  Typography,
  Paper,
  Stack,
  useTheme,
} from "@mui/material";
import {
  LightMode as LightModeIcon,
  DarkMode as DarkModeIcon,
} from "@mui/icons-material";
import { useThemeContext } from "../../contexts/ThemeContext";

const ThemeToggle: React.FC = () => {
  const { mode, toggleTheme } = useThemeContext();
  const theme = useTheme();
  const isDark = mode === "dark";

  return (
    <Paper
      elevation={2}
      sx={{
        p: 3,
        borderRadius: 2,
        backgroundColor: "background.paper",
      }}
    >
      <Stack spacing={2}>
        <Typography
          variant="h6"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            color: "text.primary",
          }}
        >
          {isDark ? (
            <DarkModeIcon color="primary" />
          ) : (
            <LightModeIcon color="primary" />
          )}
          Appearance
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Choose between light and dark theme for a comfortable viewing
          experience.
        </Typography>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Stack direction="row" spacing={2} alignItems="center">
            <LightModeIcon
              sx={{
                color: !isDark ? "primary.main" : "text.disabled",
                fontSize: "1.5rem",
              }}
            />
            <Typography
              variant="body1"
              sx={{
                color: !isDark ? "text.primary" : "text.secondary",
                fontWeight: !isDark ? 600 : 400,
              }}
            >
              Light
            </Typography>
          </Stack>

          <FormControlLabel
            control={
              <Switch
                checked={isDark}
                onChange={toggleTheme}
                color="primary"
                size="medium"
                sx={{
                  "& .MuiSwitch-thumb": {
                    backgroundColor: isDark
                      ? "#ffffff"
                      : theme.palette.grey[300],
                  },
                  "& .MuiSwitch-track": {
                    backgroundColor: isDark
                      ? theme.palette.primary.main
                      : theme.palette.grey[400],
                  },
                }}
              />
            }
            label=""
            sx={{ margin: 0 }}
          />

          <Stack direction="row" spacing={2} alignItems="center">
            <Typography
              variant="body1"
              sx={{
                color: isDark ? "text.primary" : "text.secondary",
                fontWeight: isDark ? 600 : 400,
              }}
            >
              Dark
            </Typography>
            <DarkModeIcon
              sx={{
                color: isDark ? "primary.main" : "text.disabled",
                fontSize: "1.5rem",
              }}
            />
          </Stack>
        </Box>

        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ mt: 1, fontStyle: "italic" }}
        >
          Your preference will be saved automatically
        </Typography>
      </Stack>
    </Paper>
  );
};

export default ThemeToggle;
